<template>
  <div class="tradehtml">
    <div class="tradeall">
      <div class="tradehead">
        <div class="tradeheadtext">
          <p
            style="
              font-size: 18px;
              color: #275479;
              font-weight: bold;
              line-height: 30px;
            "
          >
            交易通道
          </p>
          <p style="margin-top: 5px; font-size: 15px; letter-spacing: 1px">
            提示：文华财经只是一家软件服务公司，开户/入金等业务请另外找期货公司办理。
          </p>
        </div>
      </div>
      <div class="tradebody">
        <div class="tradebodyhead">
          <div
            v-bind:class="[form.guonei ? class1 : class2]"
            style="
              height: 50px;
              text-align: center;
              line-height: 50px;
              font-weight: bold;
            "
            @click="changeguonei"
          >
            期货/期权
          </div>
          <div
            v-bind:class="[form.qiquan || form.guowai ? class7 : class8]"
            style="width: 3px; height: 50px"
          ></div>
          <div
            v-bind:class="[form.tzjg ? class9 : class10]"
            style="
              height: 50px;
              text-align: center;
              line-height: 50px;
              font-weight: bold;
            "
            @click="changejg"
          >
            投资机构
          </div>
          <!-- <div
            v-bind:class="[form.guowai||form.guonei ? class7 : class8]"
            style="width: 3px; height: 50px"
          ></div>
          <div
            v-bind:class="[form.qiquan ? class5 : class6]"
            style="
              height: 50px;
              text-align: center;
              line-height: 50px;
              font-weight: bold;
            "
            @click="changeqiquan"
          >
            股票期权
          </div> -->
        </div>
        <div class="tradebodybody">
          <guonei v-if="form.guonei"></guonei>
          <tzjg v-if="form.tzjg"></tzjg>
          <guowai v-if="form.guowai"></guowai>
          <!-- <qiquan v-if="form.qiquan"></qiquan> -->
        </div>
      </div>
      <div style="height: 40px"></div>
    </div>
    <wh7footer></wh7footer>
  </div>
</template>

<script>
import guonei from "./components/trade/guoneinew.vue";
import guowai from "./components/trade/guowai.vue";
import qiquan from "./components/trade/qiquan.vue";
import tzjg from "./components/trade/tzjg.vue";
import wh7footer from "./components/wh7/wh7footer.vue";
export default {
  components: { guonei, guowai, qiquan, tzjg, wh7footer },
  data() {
    return {
      form: {
        guonei: true,
        guowai: false,
        qiquan: false,
        tzjg: false,
      },
      class1: "clickchange1",
      class2: "nochange1",
      class3: "clickchange2",
      class4: "nochange2",
      class5: "clickchange3",
      class6: "nochange3",
      class7: "kongxi",
      class8: "nokongxi",
      class9: "clickchange4",
      class10: "nochange4",
    };
  },
  methods: {
    changeguonei() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.guonei = true;
    },
    changeguowai() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.guowai = true;
    },
    changeqiquan() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.qiquan = true;
    },
    changejg() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.tzjg = true;
    },
  },
};
</script>

<style  scoped>
.tradehtml {
  min-width: 1400px;
  width: 100%;
  background-size: auto 1000px;
  min-height: 835px;
  z-index: 3;
  margin: 0 auto;
  background: #eef0ff;
}
.tradeall {
  background: url("../../assets/images/jytd-bg_02.1c8097d3.jpg") no-repeat top;
  background-size: 100% auto;
  min-width: 1400px;
  width: 100%;
}
.tradehead {
  position: relative;
  height: 160px;
  width: 1000px;
  margin: 0 auto;
}
.tradeheadtext {
  position: absolute;
  top: 100px;
}
.tradebody {
  width: 1006px;
  min-height: 655px;
  margin: 0 auto;
}
.tradebodyhead {
  width: 1006px;
  height: 50px;
  vertical-align: bottom;
}
.clickchange1 {
  width: 503px;
  float: left;
  background: white;
  box-shadow: inset 0px 5px 0px#364064;
  -webkit-box-shadow: inset 0px 5px 0px#364064;
  -ms-box-shadow: inset 0px 5px 0px#364064;
  -moz--box-shadow: inset 0px 5px 0px#364064;
  color: #364064;
  filter: drop-shadow(0px 4px 2px #b9b9b8);
  cursor: pointer;
}

.nochange1 {
  width: 503px;

  float: left;
  background: url("../../assets/images/xiaz-b.jpg");
  filter: alpha(opacity=350);
  -moz-opacity: 3.5;
  -khtml-opacity: 3.5;
  opacity: 3.5;
  color: #626e9d;
  cursor: pointer;
}
.nothing {
  padding-top: 5px;
  float: left;
}
.tradebodybody {
  margin-top: -1px;
  width: 1006px;
  min-height: 560px;

  filter: drop-shadow(0px 4px 2px #b9b9b8);
  padding-top: 45px;
  background: white;
}
.tradetable {
  width: 720px;
  margin: 0 auto;
}
.clickchange2 {
  width: 333px;
  float: left;
  background: white;
  box-shadow: inset 0px 5px 0px#364064;
  -webkit-box-shadow: inset 0px 5px 0px#364064;
  -ms-box-shadow: inset 0px 5px 0px#364064;
  -moz--box-shadow: inset 0px 5px 0px#364064;
  color: #364064;
  filter: drop-shadow(0px 4px 2px #b9b9b8);
  cursor: pointer;
}
.nochange2 {
  width: 333px;

  float: left;
  background: url("../../assets/images/xiaz-b.jpg");
  filter: alpha(opacity=350);
  -moz-opacity: 3.5;
  -khtml-opacity: 3.5;
  opacity: 3.5;
  color: #626e9d;
  cursor: pointer;
}
.clickchange3 {
  width: 500px;
  float: left;
  background: white;
  box-shadow: inset 0px 5px 0px#364064;
  -webkit-box-shadow: inset 0px 5px 0px#364064;
  -ms-box-shadow: inset 0px 5px 0px#364064;
  -moz--box-shadow: inset 0px 5px 0px#364064;
  color: #364064;
  filter: drop-shadow(0px 4px 2px #b9b9b8);
  cursor: pointer;
}
.nochange3 {
  width: 500px;

  float: left;
  background: url("../../assets/images/xiaz-b.jpg");
  filter: alpha(opacity=350);
  -moz-opacity: 3.5;
  -khtml-opacity: 3.5;
  opacity: 3.5;
  color: #626e9d;
  cursor: pointer;
}
.nochange4 {
  width: 500px;

  float: left;
  background: url("../../assets/images/xiaz-b.jpg");
  filter: alpha(opacity=350);
  -moz-opacity: 3.5;
  -khtml-opacity: 3.5;
  opacity: 3.5;
  color: #626e9d;
  cursor: pointer;
}
.clickchange4 {
  width: 500px;
  float: left;
  background: white;
  box-shadow: inset 0px 5px 0px#364064;
  -webkit-box-shadow: inset 0px 5px 0px#364064;
  -ms-box-shadow: inset 0px 5px 0px#364064;
  -moz--box-shadow: inset 0px 5px 0px#364064;
  color: #364064;
  filter: drop-shadow(0px 4px 2px #b9b9b8);
  cursor: pointer;
}
.kongxi {
  background: #b3ccee;
  float: left;
}
.nokongxi {
  background: url("../../assets/images/xiaz-b.jpg");
  float: left;
}
</style>